export default __webpack_public_path__ + "static/box_b.46189a52ba89bbd5e28228fe84cde53e.svg";